import ListTabView from '../../components/common/tabView';
import SurgeryRecommendation from "./SurgeryRecommendation.jsx";
import GlassesPrescription from "./GlassesPrescription";
import MedicalPrescription from "./MedicalPrescription.jsx";

export default function PatientTreatment({ patientVisitId,initialId }) {
  return (
    <div>
      <div className="my-2 public_sans_500 text-lg text-secondaryTextColor">
        Treatment
      </div>
      <div className="mt-4">
        <ListTabView
          type={"secondary"}
          defaultIndex={0}
          listComponent={[
            {
              header: "Medical Prescription",
              content: <MedicalPrescription patientVisitId={patientVisitId} initialId={initialId} />,
            },
            {
              header: "Glasses Prescription",
              content: <GlassesPrescription patientVisitId={patientVisitId} />,
            },
            {
              header: "Surgery Recommendation",
              content: (
                <SurgeryRecommendation patientVisitId={patientVisitId} />
              ),
            },
          ]}
        />
      </div>
    </div>
  );
}
